import { type ZodErrorMap, ZodIssueCode } from 'zod'

const customErrorMap: ZodErrorMap = (issue, ctx) => {
  switch (issue.code) {
    case ZodIssueCode.invalid_type:
      if (issue.expected === 'string') {
        return { message: '必须是字符串类型' }
      } else if (issue.expected === 'number') {
        return { message: '必须是数字类型' }
      } else if (issue.expected === 'boolean') {
        return { message: '必须是布尔类型' }
      } else if (issue.expected === 'date') {
        return { message: '必须是日期类型' }
      }
      break
    case ZodIssueCode.too_small:
      if (issue.type === 'string') {
        return { message: `长度不能小于 ${issue.minimum} 个字符` }
      } else if (issue.type === 'array') {
        return { message: `数组长度不能小于 ${issue.minimum} 个元素` }
      }
      break
    case ZodIssueCode.too_big:
      if (issue.type === 'string') {
        return { message: `长度不能超过 ${issue.maximum} 个字符` }
      } else if (issue.type === 'array') {
        return { message: `数组长度不能超过 ${issue.maximum} 个元素` }
      }
      break
    case ZodIssueCode.invalid_enum_value:
      return { message: '无效的枚举值' }
    case ZodIssueCode.invalid_union:
      return { message: '值不符合联合类型中的任何一种' }
    case ZodIssueCode.invalid_union_discriminator:
      return { message: '联合类型的判别式无效' }
    case ZodIssueCode.invalid_date:
      return { message: '无效的日期格式' }
    case ZodIssueCode.invalid_intersection_types:
      return { message: '值不符合交集类型的要求' }
    case ZodIssueCode.invalid_literal:
      return { message: `预期值为 ${JSON.stringify(issue.expected)}，但接收到 ${JSON.stringify(issue.received)}` }
    case ZodIssueCode.unrecognized_keys:
      return { message: `存在未识别的键: ${issue.keys.join(', ')}` }
    case ZodIssueCode.invalid_arguments:
      return { message: '参数无效' }
    case ZodIssueCode.invalid_return_type:
      return { message: '返回类型无效' }
    case ZodIssueCode.invalid_string:
      if (typeof issue.validation === 'string') {
        return { message: `字符串不符合 ${issue.validation} 格式` }
      } else if ('includes' in issue.validation) {
        return { message: `字符串必须包含 ${issue.validation.includes}` }
      } else if ('startsWith' in issue.validation) {
        return { message: `字符串必须以 ${issue.validation.startsWith} 开头` }
      } else if ('endsWith' in issue.validation) {
        return { message: `字符串必须以 ${issue.validation.endsWith} 结尾` }
      }
      break
    case ZodIssueCode.not_multiple_of:
      return { message: `值必须是 ${issue.multipleOf} 的倍数` }
    case ZodIssueCode.not_finite:
      return { message: '值必须是有限的' }
    case ZodIssueCode.custom:
      return { message: `自定义错误: ${issue.params ? JSON.stringify(issue.params) : '无参数'}` }
    default:
      break
  }
  return { message: ctx.defaultError }
}

export default customErrorMap
